import { render, staticRenderFns } from "./FormularioAlteraValores.vue?vue&type=template&id=4cc3a469&scoped=true&"
import script from "./FormularioAlteraValores.vue?vue&type=script&lang=ts&"
export * from "./FormularioAlteraValores.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioAlteraValores.vue?vue&type=style&index=0&id=4cc3a469&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc3a469",
  null
  
)

export default component.exports